/**
 * sentryUserSync.ts
 *
 * Lane 0 (docs/designs/observability-and-usage-metering.md): customer +
 * task context, client half. Server-side has an equivalent
 * (server/lib/sentryRequestContext.js); before either existed, no code path
 * on either side called Sentry.setUser()/setTag(), so a client-side error
 * reached Sentry with no indication of which customer hit it.
 *
 * Extracted into its own pure function (rather than inlined in a
 * useEffect in AuthContext.tsx) so it's unit-testable without rendering the
 * whole AuthProvider tree (which pulls in authAPI, localStorage, PostHog,
 * etc.). AuthContext.tsx calls this from a `useEffect(() => { syncSentryUser
 * (Sentry, user); }, [user])`, which fires on every user state transition —
 * initial load, login, token refresh, and logout — regardless of which of
 * AuthContext's several `setUser` call sites triggered it.
 */

type MinimalSentry = {
  setUser: (user: { id: string } | null) => void;
};

type MinimalUser = { id: string } | null | undefined;

export function syncSentryUser(Sentry: MinimalSentry, user: MinimalUser): void {
  Sentry.setUser(user ? { id: String(user.id) } : null);
}
